import TableViewIcon from "@mui/icons-material/TableView";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { GridApiPro } from "@mui/x-data-grid-pro";
import { MutableRefObject } from "react";
import { useTranslation } from "react-i18next";
import { exportGridAsExcel } from "@/components/grid/CustomToolbar/GridExcelExportMenuItem";

interface Props {
  apiRef: MutableRefObject<GridApiPro>;
  disabled?: boolean;
}

export function LogbookExcelExportButton({ apiRef, disabled }: Props) {
  const { t } = useTranslation();

  return (
    <Tooltip title={t("logbookEdit.export.tooltip")}>
      <span>
        <Button
          variant="outlined"
          size="small"
          onClick={() => exportGridAsExcel(apiRef)}
          disabled={disabled}
          startIcon={<TableViewIcon />}
          sx={{ whiteSpace: "nowrap" }}
        >
          {t("logbookEdit.export.label")}
        </Button>
      </span>
    </Tooltip>
  );
}
